export default __webpack_public_path__ + "static/media/PRZYLOZ_OPASKE.f802eb68.png";